import {Action} from "../../../feature/project/Shot";
import {useEffect, useState} from "react";

export const AudioElement = (props: {
    actions: Action[],
    onPlayEnd: (type: string) => void,
    isPlaying: boolean
}) => {

    const [queue, setQueue] = useState<AudioAction[]>([])

    useEffect(() => {
        queue.forEach((action) => {
            action.stop()
        })

        function parseAudios(actions: Action[]): AudioAction[] {
            return actions
                .filter((action, index) => action.arguments.filter((argument) => argument.title == "playSound").length > 0)
                .map((action) => {
                    const url = action.arguments.find((argument) => argument.title == "playSound")!!.value
                    const delay = action.arguments.find((argument) => argument.title == "delay")?.value
                    const volume = action.arguments.find((argument) => argument.title == "volume")?.value
                    const repeat = action.arguments.find((argument) => argument.title == "repeat")?.value
                    return new AudioAction(new Audio(url), delay ? parseInt(delay) : 0, volume ? parseFloat(volume) : 1.0, repeat ? parseInt(repeat) : 1)
                })
        }

        setQueue(parseAudios(props.actions))
    }, [props.actions]);

    useEffect(() => {
        if (props.isPlaying) {
            queue.forEach((action) => {
                action.play()
            })
        } else {
            queue.forEach((action) => {
                action.stop()
            })
        }
    }, [props.isPlaying]);
    return (<>

    </>)
}

class AudioAction {
    audio: HTMLAudioElement
    delay: number
    volume: number
    repeat: number

    constructor(audio: HTMLAudioElement, delay: number, volume: number, repeat: number) {
        this.audio = audio
        this.delay = delay
        this.volume = volume
        this.repeat = repeat
    }

    play() {
        let played = 0

        const playAudio = () => {
            this.audio.load();
            this.audio.volume = this.volume;
            this.audio.play();

            played++;

            this.audio.onended = () => {
                if (this.repeat == 0 || played < this.repeat) {
                    playAudio();
                }
            };
        };

        // Start playing with the delay
        setTimeout(() => {
            playAudio();
        }, this.delay);
    }

    stop() {
        this.audio.pause()
        this.audio.currentTime = 0
    }
}